import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import translate from '../../services/translation';
import NumberFormat from 'react-number-format';
import PriceInformation from "../Planner/PriceInformation";
import {AddFavouritesApp} from "../../apps/AddFavouritesApp";

export default class ItineraryTeaserTile extends Component {
    static propTypes = {
        id: PropTypes.number,
        favouriteLink: PropTypes.string,
        teaser: PropTypes.shape({
            contentType: PropTypes.string,
            layout: PropTypes.number,
            publicImagePath: PropTypes.string,
            publicRetinaImagePath: PropTypes.string,
            publicLink: PropTypes.string,
            title: PropTypes.string,
            teaser: PropTypes.string,
            stringDateTime: PropTypes.string,
            additionalData: PropTypes.shape({
                uid: PropTypes.number,
                inRiverImage: PropTypes.string,
                price: PropTypes.number,
                serviceFeeText: PropTypes.string,
                label: PropTypes.string,
                isInstantBookable: PropTypes.bool,
                travelArea: PropTypes.string,
                soldOut: PropTypes.bool,
                priceInformation: PropTypes.string,
                priceValidityPeriod: PropTypes.string
            })
        })
    };

    getTeaserInstantBookable() {
        return (
            <React.Fragment>
                {this.props.teaser.additionalData.isInstantBookable && (
                    <div className="teaserInstantBookableContainer">
                        <div className="teaserInstantBookable" title={translate('label_instantbookable_headline')}></div>
                    </div>
                )}
            </React.Fragment>
        )
    }

    getTeaserImageContainer() {
        return (
            <div className="teaserImageContainer">
                <div className="teaserImageWrapper">
                    <picture>
                        <source srcSet={this.props.teaser.additionalData.inRiverImage}/>
                        <img className="teaserImage" src={this.props.teaser.additionalData.inRiverImage} alt=""/>
                    </picture>
                    {this.props.teaser.additionalData.travelArea &&
                        <div className="teaserValidityPeriod">
                            <div className="teaserTravelArea">{this.props.teaser.additionalData.travelArea}</div>
                        </div>
                    }
                </div>
            </div>
        );
    }

    getTeaserTextContainer() {
        return (
            <div className="teaserTextContainer">
                <div className="teaserTitle">{this.props.teaser.title}</div>
                <div className="teaserTeaser">{_.truncate(this.props.teaser.teaser, {length: 200})}</div>
                {(this.props.teaser.additionalData.priceValidityPeriod || this.props.teaser.additionalData.price !== 0) &&
                    <div className="teaserFooter">
                        {this.props.teaser.additionalData.priceValidityPeriod &&
                            <div className="teaserValidityPeriod">
                                {this.props.teaser.additionalData.priceValidityPeriod}
                            </div>
                        }
                        {this.props.teaser.additionalData.price !== 0 &&
                            <div className="teaserPrice">
                                <PriceInformation priceInformation={this.props.teaser.additionalData.priceInformation} />
                                <span className="fromPriceText">{translate('itinerary_item.from')} </span>
                                <span className="fromPrice"><NumberFormat prefix={'Fr. '} value={this.props.teaser.additionalData.price} displayType='text' thousandSeparator={"'"} suffix={'.-'} /></span>
                            </div>
                        }
                    </div>
                }
                {this.props.teaser.additionalData.serviceFeeText !== "" &&
                    <div className="favouriteItemServiceFeeText">
                        {this.props.teaser.additionalData.serviceFeeText}
                    </div>
                }
            </div>
        );
    }

    getClasses() {
        let classes = [
            'teaserTile',
            this.props.teaser.contentType + 'TeaserTile'
        ];

        if(this.props.teaser.layout){
            classes.push('layoutBig')
        } else {
            classes.push('layoutTeaserDefault')
        }

        return classes.join(' ');
    }

    getLink() {
        return this.props.teaser.publicLink;
    }

    render() {
        return (
            <div className={this.getClasses()}>
                <AddFavouritesApp itineraryUid={this.props.teaser.additionalData.uid} favouriteType={this.props.teaser.contentType} favouriteLink={this.props.favouriteLink}/>

                <a href={this.getLink()} className="teaserLink">
                    {this.getTeaserInstantBookable()}
                    {this.getTeaserImageContainer()}
                    {this.getTeaserTextContainer()}
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TeaserTile/ItineraryTeaserTile.js